import { ClassAttributes, HTMLAttributes } from "react";
import { Tilerail } from "./Tilerail";
import { Interpolation, Theme, css } from "@emotion/react";
import styled from "@emotion/styled";

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 160px;
  background-color: ${({ theme }) => theme.color.grey_f2};
  border-radius: 12px;
  user-select: none;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 88px;
  }
`;

const BannerTitle = styled.h1`
  font-weight: 400;
  font-size: 24px;
  line-height: 1.35;
  white-space: pre-wrap;
  margin: 0;
  margin-bottom: 12px;

  @media (max-width: 1024px) {
    font-size: 24px;
    margin-bottom: 8px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 0;
  }
`;

const BannerDesc = styled.h2`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.grey_a};
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const TailContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 8px;

    @media (max-width: 1024px) {
      margin-right: 8px;
    }
  }
`;

export const MainBanner = ({
  ...props
}: ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    css?: Interpolation<Theme>;
  }) => {
  return (
    <Container {...props}>
      <TailContainer
        css={css`
          right: 18%;

          @media (max-width: 1024px) {
            display: none;
          }
        `}
      >
        <Tilerail
          direction={1}
          items={[
            "/tile_1.png",
            "/tile_2.png",
            "/tile_3.png",
            "/tile_4.png",
            "/tile_5.png",
          ]}
          edge={80}
          duration={15}
          height={160}
          gap={8}
        />
        <Tilerail
          direction={-1}
          items={[
            "/tile_6.png",
            "/tile_7.png",
            "/tile_8.png",
            "/tile_9.png",
            "/tile_10.png",
          ]}
          edge={80}
          duration={15}
          height={160}
          gap={8}
        />
        <Tilerail
          direction={1}
          items={[
            "/tile_11.png",
            "/tile_12.png",
            "/tile_13.png",
            "/tile_14.png",
            "/tile_15.png",
          ]}
          edge={80}
          duration={15}
          height={160}
          gap={8}
        />
      </TailContainer>
      <TailContainer
        css={css`
          display: none;
          right: 10%;

          @media (max-width: 1024px) {
            display: flex;
          }

          @media (max-width: 768px) {
            display: none;
          }
        `}
      >
        <Tilerail
          direction={1}
          items={[
            "/tile_1.png",
            "/tile_2.png",
            "/tile_3.png",
            "/tile_4.png",
            "/tile_5.png",
          ]}
          edge={64}
          duration={15}
          height={173}
          gap={8}
        />
        <Tilerail
          direction={-1}
          items={[
            "/tile_6.png",
            "/tile_7.png",
            "/tile_8.png",
            "/tile_9.png",
            "/tile_10.png",
          ]}
          edge={64}
          duration={15}
          height={173}
          gap={8}
        />
        <Tilerail
          direction={1}
          items={[
            "/tile_11.png",
            "/tile_12.png",
            "/tile_13.png",
            "/tile_14.png",
            "/tile_15.png",
          ]}
          edge={64}
          duration={15}
          height={173}
          gap={8}
        />
      </TailContainer>
      <TailContainer
        css={css`
          display: none;
          right: 24px;

          @media (max-width: 768px) {
            display: flex;
          }
        `}
      >
        <Tilerail
          direction={1}
          items={[
            "/tile_1.png",
            "/tile_2.png",
            "/tile_3.png",
            "/tile_4.png",
            "/tile_5.png",
            "/tile_6.png",
            "/tile_7.png",
            "/tile_8.png",
            "/tile_9.png",
            "/tile_10.png",
            "/tile_11.png",
            "/tile_12.png",
            "/tile_13.png",
            "/tile_14.png",
            "/tile_15.png",
          ]}
          edge={56}
          duration={20}
          height={130}
          gap={8}
        />
      </TailContainer>
      <div
        css={css`
          position: absolute;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          z-index: 1;
          height: 100%;
          padding: 0 13%;
          border-radius: 12px;
          background: linear-gradient(
            to right,
            rgba(242, 242, 242, 1) 90%,
            rgba(242, 242, 242, 0) 100%
          );

          @media (max-width: 768px) {
            padding: 0 24px;
          }
        `}
      >
        <BannerTitle>
          마케터들의 영감이 쌓이는 공간,{"\n"}믹스로 초대합니다.
        </BannerTitle>
        <BannerDesc>
          마케팅 인사이트가 돋보이는{"\n"}콘텐츠를 엄선하여 소개합니다.
        </BannerDesc>
      </div>
    </Container>
  );
};
